import React from 'react';
import TileGroup from './TileGroup';
import PersonalForeignObject from './PersonalForeignObject';

interface ComponentConfig {
    component: React.ComponentType<any>;
    props: {
        cx?: number;
        cy?: number;
        r?: number;
        tx?: number;
        ty?: number;
        texture?: string;
    };
    key: string;
}

interface PersonalProps {
    specialTiles: ComponentConfig[];
    facadeTiles: [number, number][];
    groupCoordinates: [number, number][];
}

const Personal: React.FC<PersonalProps> = ({ specialTiles, facadeTiles, groupCoordinates }) => {
    return (
        <TileGroup
            specialTiles={specialTiles}
            facadeTiles={facadeTiles}
            groupCoordinates={groupCoordinates}
            groupName="personal"
            displayText="PERSONAL"
            backgroundTexture="/textures/oak_planks.png"
            foreignObjectComponent={PersonalForeignObject}
            zoomScale={3.5}
        />
    );
};

export default Personal;